// AUTH ACTIONS
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const PROFILE_PIC_UPLOAD = 'PROFILE_PIC_UPLOAD';
export const PROFILE_PIC_REMOVE = 'PROFILE_PIC_REMOVE';
export const UPDATE_USER = 'UPDATE_USER';
export const ADD_RECORD = 'ADD_RECORD';
export const DELETE_RECORD = 'DELETE_RECORD';

// BACKDROP ACTIONS
export const BDROP_SET = 'BDROP_SET';
export const BDROP_UNSET = 'BDROP_UNSET';

// SNACKBAR ACTIONS
export const ALERT_SET = 'ALERT_SET';
export const ALERT_UNSET = 'ALERT_UNSET';
export const ALERT_ERROR = 'ALERT_ERROR';

// FORM ACTIONS
export const FORM_SET_DATA = 'FORM_SET_DATA';
export const FORM_RESET = 'FORM_RESET';

// OVERLAY ACTIONS
export const OVERLAY_SET = 'OVERLAY_SET';
export const OVERLAY_UNSET = 'OVERLAY_UNSET';

// DASHBOARD ACTIONS
export const DASH_SELECTED_MENU = 'DASH_SELECTED_MENU';

// PROVIDER ACTIONS
export const CREATE_PROVIDER_ACC = 'CREATE_PROVIDER_ACC';
export const LOAD_PROVIDER_DATA = 'LOAD_PROVIDER_DATA';
export const LOAD_ALL_DOCTORS = 'LOAD_ALL_DOCTORS';
export const START_LOAD_ALL_DOCTORS = 'START_LOAD_ALL_DOCTORS';

// APPOINTMENT ACTIONS
export const BOOK_APPOINTMENT = 'BOOK_APPOINTMENT';
export const UPDATE_APPOINTMENT = 'UPDATE_APPOINTMENT';
export const FETCH_USER_APPOINTMENTS = 'FETCH_USER_APPOINTMENTS';
export const FETCH_DOCTOR_APPOINTMENTS = 'FETCH_DOCTOR_APPOINTMENTS';
